module.exports = __webpack_public_path__ + "static/media/change.5da4807b.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/change.png
// module id = 1852
// module chunks = 146